import React from "react";
import Style from "../../styles/js/StyleNotifications.js";
import { ColorButton } from "../../components/common/CustomButton.js";
import Button from "@material-ui/core/Button";
import * as ScreenText from "../../consts/ScreenText.js";

export default function NotificationsForm({
  setInitialState,
  handleSubmit,
  disabled,
}) {
  const style = Style();

  return (
    <div>
      <ColorButton
        onClick={handleSubmit}
        className={style.actionButton}
        variant="contained"
        disabled={disabled}
      >
        {ScreenText.NOTIFICATIONS_BUTTON_SUBMIT}
      </ColorButton>
      <Button
        className={style.actionButton}
        onClick={setInitialState}
        variant="contained"
      >
        {ScreenText.NOTIFICATIONS_BUTTON_RESET}
      </Button>
    </div>
  );
}
